import { Skeleton } from "../../../../../components/shared";
import ProgressiveContractLoader from "../../../../../components/Chats/ProgressiveContractLoader";
import { ContractGenerateIcon } from "../../../../../assets/icons/ContractGenerate";
import { isContractInProgress } from "../../../../../components/AIChat/contractStates";

export const ContractPanelContent = ({
  contracts,
  selectedContractId,
  contractDetail,
  contractLoading,
  contractState,
  intentData,
  activeSessionId,
}) => {
  const contractFileUrl = contractDetail?.file_link || "";
  const contractProgressMessage = contractState.progressMessage;

  if (!activeSessionId) {
    return (
      <div className="h-full flex items-center justify-center text-sm text-mediumgrey text-center text-pretty">
        Select a session
      </div>
    );
  }

  // Show generating state for any in-progress status
  if (isContractInProgress(contractState.status)) {
    return (
      <div className="h-full">
        <ProgressiveContractLoader
          contractTitle={intentData?.title || contractDetail?.title || "Contract"}
          progress={contractState.progress}
          progressMessage={contractProgressMessage}
          error={contractState.error}
        />
      </div>
    );
  }

  // Show failed state
  if (contractState.status === "failed") {
    return (
      <div className="h-full flex flex-col items-center justify-center text-center gap-3">
        <p className="text-sm text-danger text-pretty">
          {contractState.error || "Generation failed."}
        </p>
        <p className="text-xs text-mediumgrey text-pretty">
          Start a new request to try generating the contract again.
        </p>
      </div>
    );
  }

  // No contracts yet
  if (!selectedContractId && contracts.length === 0) {
    return (
      <div className="h-full flex flex-col items-center justify-center text-center gap-3">
        <div className="relative">
          <ContractGenerateIcon
            width={32}
            height={32}
            className="text-primary/30 animate-pulse"
          />
        </div>
        <div className="space-y-1">
          <p className="text-xs font-medium text-mediumgrey text-pretty">
            Waiting for AI to generate a contract
          </p>
          <p className="text-[11px] text-grey text-pretty">
            Send a message to begin drafting
          </p>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="h-1.5 w-1.5 rounded-full bg-primary/30 animate-pulse" />
          <span className="h-1.5 w-1.5 rounded-full bg-primary/30 animate-pulse [animation-delay:150ms]" />
          <span className="h-1.5 w-1.5 rounded-full bg-primary/30 animate-pulse [animation-delay:300ms]" />
        </div>
      </div>
    );
  }

  // Show contract preview
  return (
    <div className="flex flex-col h-full">
      {selectedContractId && (
        <div className="flex-1 min-h-0">
          {contractLoading ? (
            <div className="space-y-3">
              <Skeleton className="h-6 w-2/3 rounded" />
              <Skeleton className="h-32 w-full rounded" />
            </div>
          ) : contractFileUrl ? (
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between mb-3">
                <h4 className="text-sm font-semibold text-primary truncate">
                  {contractDetail?.title || "Contract"}
                </h4>
                <a
                  href={contractFileUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs text-primary hover:underline font-medium shrink-0"
                >
                  Download
                </a>
              </div>
              <div className="flex-1 bg-white border border-surface-border rounded-lg overflow-hidden shadow-sm min-h-0">
                <iframe
                  title="Contract Preview"
                  src={contractFileUrl}
                  className="w-full h-full"
                />
              </div>
            </div>
          ) : (
            <div className="h-full flex flex-col items-center justify-center text-center gap-3">
              <ContractGenerateIcon
                width={32}
                height={32}
                className="text-primary/30 animate-pulse"
              />
              <p className="text-xs text-mediumgrey text-pretty">
                PDF not available
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
